import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=a89ddf70&scoped=true&"
import script from "./Ideas.vue?vue&type=script&lang=ts&"
export * from "./Ideas.vue?vue&type=script&lang=ts&"
import style0 from "./Ideas.vue?vue&type=style&index=0&id=a89ddf70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89ddf70",
  null
  
)

export default component.exports